export const METHODFI_FLOW_VARIATIONS = {
  off: 0,
  softSkip: 1,
  immediateSkip: 2,
  nameZipNoMethodFi: 3,
} as const;
